import { makeGraphQLRequest } from '../utils/requestUtils';

export default async function getCodeDefinitions(codeName) {
  // Format Query
  const query = `query codeDefinitionList(
    $codeName: String
  ) {
      codeDefinitionList(codeName: $codeName) {
        codeDefinitions {
          codeValue
          codeDefinition
          codeDescription
        }     
      }
    }`;

  // Variables
  const variables = { codeName };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response.codeDefinitionList.codeDefinitions;
}



// WEBPACK FOOTER //
// ./src/graphql/codeDefinitions.js